import { useDispatch, useSelector } from 'react-redux';
import { Building2, Check } from 'lucide-react';
import { changeCurrentCompany } from '@/store/actions/auth';
import { SpinnerOverlay } from '@/components/ui/Spinner';
import { cn } from '@/utils/cn';

function ProfileItem({ employee, history, isCurrent }) {
  const dispatch = useDispatch();

  const changeCompany = () => {
    dispatch(changeCurrentCompany(employee.id, employee.company.id));
    history.push('/');
  };

  return (
    <li
      data-testid={`profiles-employee-${employee.id}-item`}
      onClick={changeCompany}
      className={cn(
        'flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors',
        isCurrent ? 'bg-primary-50' : 'hover:bg-neutral-50'
      )}
    >
      <div
        className={cn(
          'h-8 w-8 rounded flex items-center justify-center shrink-0',
          isCurrent ? 'bg-primary-100 text-primary-700' : 'bg-neutral-100 text-neutral-500'
        )}
      >
        <Building2 size={14} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-xs text-neutral-500">{employee.role?.title}</div>
        <div className="text-sm font-medium text-neutral-900 truncate">
          {employee.company?.title}
        </div>
      </div>
      {isCurrent && <Check size={14} className="text-primary-600 shrink-0" />}
    </li>
  );
}

function Profiles(props) {
  const { loadingMenu } = useSelector((state) => state.menu);
  const { current_employee } = useSelector((state) => state.auth);

  return (
    <ul className="max-h-[300px] overflow-y-auto border-t border-neutral-150">
      {loadingMenu && (
        <div className="flex justify-center items-center py-4">
          <SpinnerOverlay />
        </div>
      )}
      {(props.employees || []).map((employee) => (
        <ProfileItem
          key={employee.id}
          employee={employee}
          history={props.history}
          isCurrent={employee.id === current_employee}
        />
      ))}
    </ul>
  );
}

export default Profiles;
